import { component } from 'picoapp';
import Glide from '@glidejs/glide';

export default component((node) => {
  const carousel = node.querySelector('.js-testimonial-carousel');
  const { slideCount } = carousel.dataset;
  const prev = node.querySelector('[data-glide-dir="<"]');
  const next = node.querySelector('[data-glide-dir=">"]');


  const glide = new Glide(carousel, {
    type: 'slider',
    rewind: false,
    startAt: 0,
    perView: 1,
    animationDuration: 500,
  });

  const updateButtonStates = () => {
    prev.removeAttribute('disabled');
    next.removeAttribute('disabled');

    if (glide.index == slideCount - 1) {
      next.setAttribute('disabled', '');
    }

    if (glide.index == 0) {
      prev.setAttribute('disabled', '');
    }
  };

  glide.on(['mount.after', 'run'], updateButtonStates);


  glide.mount();
});

